import styled from '@emotion/styled';
import { TextStyle } from '../../../styles/variables/mixins';
import { Colors } from '../../../styles/variables/colors';
import { Variables } from '../../../styles/variables/variables';
import { ReactComponent as CrossSimpleIconIcons } from 'assets/icons/cross-simple.svg';
import IconBtnIcon from 'components/common/IconBtn';

const { darkGray, lightGrayBorder, white, gray, consultationButton, inputBorder } = Colors;
const { assistant } = Variables;

export const Button = styled.button<{ secondarybtn: boolean }>`
    min-width: ${({ secondarybtn }) => (secondarybtn ? '165px' : '180px')};
    padding: ${({ secondarybtn }) => (secondarybtn ? '12px 16px' : '12px 30px')};
    background-color: ${({ secondarybtn }) => (secondarybtn ? inputBorder : consultationButton)};
    border-radius: 50px;
    ${TextStyle({ fontSize: '12px', fontWeight: '700' })};
    font-style: normal;
    line-height: 17px;
    text-transform: capitalize;
    color: ${({ secondarybtn }) => (secondarybtn ? darkGray : white)};
    transition: all 110ms ease-out;

    &:hover {
        background-color: ${({ secondarybtn }) => (secondarybtn ? lightGrayBorder : white)};
        color: ${({ secondarybtn }) => (secondarybtn ? gray : consultationButton)};
        border: ${({ secondarybtn }) =>
            secondarybtn ? `2px solid ${inputBorder}` : `2px solid ${consultationButton}`};
    }

    &:active {
        opacity: 0.9;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    column-gap: 1.5rem;
    margin-top: 2.75rem;

    @media screen and (max-width: 580px) {
        margin-top: 1.75rem;
        flex-direction: column;
        gap: 0.5rem;
        align-items: center;
    }
`;

export const CrossSimpleIcon = styled(CrossSimpleIconIcons)`
    fill: ${darkGray};
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 32px 24px;
    width: 100%;
    height: 100%;
    ${TextStyle({ fontSize: '15px', fontWeight: '400', color: darkGray, fontFamily: assistant })};
    font-style: normal;
    line-height: 20px;
`;

export const IconBtn = styled(IconBtnIcon)`
    height: 24px;
    width: 24px;
    font-family: Assistant, sans-serif;
    font-size: 15px;
    color: rgb(40, 40, 40);
`;

export const Modal = styled.div`
    padding: 20px 20px;
    position: relative;
    width: 80%;
    height: 100%;
    background: ${white};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    overflow: hidden;

    :focus-visible {
        outline: none;
    }
`;

export const ModalButtonWrapper = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const ModalWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: auto;
    display: block;
    max-width: 1000px;
    width: 100%;
`;

export const Text = styled.p`
    ${TextStyle({ fontSize: '17px', fontWeight: '600', color: darkGray, fontFamily: assistant })};
    text-align: center;
`;
